import type { Routes } from '@angular/router';
import { HomePage } from './home/home.page';
import { kitRequireAuthorizedGuard } from '@rdlabo/ionic-angular-kit';

export const routes: Routes = [
  {
    path: 'files/:token',
    loadComponent: () => import('./mail-download/mail-download.page').then((m) => m.MailDownloadPage),
  },
  {
    path: '',
    component: HomePage,
    canActivate: [kitRequireAuthorizedGuard],
  },
  {
    path: 'transaction',
    loadChildren: () => import('./transaction/transaction.routes').then((m) => m.routes),
    canActivate: [kitRequireAuthorizedGuard],
  },
  {
    path: 'pre-transaction',
    loadChildren: () => import('./pre-transaction/pre-transaction.routes').then((m) => m.routes),
    canActivate: [kitRequireAuthorizedGuard],
  },
  { path: 'auth', loadChildren: () => import('../../../shared/src/auth/auth.routes').then((m) => m.routes) },
  {
    path: 'task',
    loadChildren: () => import('./task/task.routes').then((m) => m.routes),
    canActivate: [kitRequireAuthorizedGuard],
  },
  {
    path: 'search-slip',
    loadChildren: () => import('./search-slip/search-slip.routes').then((m) => m.routes),
    canActivate: [kitRequireAuthorizedGuard],
  },
  {
    path: 'search-transaction',
    loadChildren: () => import('./search-transaction/search-transaction.routes').then((m) => m.routes),
    canActivate: [kitRequireAuthorizedGuard],
  },
  {
    path: 'search-exchange',
    loadChildren: () => import('./search-exchange/search-exchange.routes').then((m) => m.routes),
    canActivate: [kitRequireAuthorizedGuard],
  },
  {
    path: 'resources',
    loadChildren: () => import('./resources/resources.routes').then((m) => m.routes),
    canActivate: [kitRequireAuthorizedGuard],
  },
  {
    path: 'control',
    loadChildren: () => import('./control/control.routes').then((m) => m.routes),
    canActivate: [kitRequireAuthorizedGuard],
  },
];
